import type * as React from 'react';

import type { ButtonName, SectionName } from '@coursera/event-pulse-types';

import useTrackClickButton from 'bundles/authentication/shared/hooks/useTrackClickButton';

type EventData = {
  name: ButtonName;
  sectionName?: SectionName;
};

type TrackEvent = ({ name }: EventData) => void;

type AuthenticationButtonTrackingProps = {
  children: (track: TrackEvent) => React.ReactElement | null;
};

const AuthenticationV3CtaTracking: React.FC<AuthenticationButtonTrackingProps> = ({ children }) => {
  const { trackButton } = useTrackClickButton();

  return children(trackButton);
};

export default AuthenticationV3CtaTracking;
